import React, { useEffect, useRef, useState } from 'react';
import { animate } from 'motion'; // Import animate from motion
import './Page7.css';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import axios from 'axios';

// Fix for default marker icon issues (keep this if you needed it before)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Define a different style for the first marker (e.g., a blue circle)
const firstMarkerStyle = { color: 'red', fillColor: 'blue', fillOpacity: 0.8 };
const otherMarkerStyle = { color: 'red', fillColor: 'red', fillOpacity: 0.8 }; // Example style for other CircleMarkers if needed


const ScrollableCards = () => {
    const mapRef = useRef(null);
    const [locations, setLocations] = useState([]);
    const [mapCenter, setMapCenter] = useState(null);
    const firstMarkerRef = useRef(null); // Ref for the first CircleMarker


    // useEffect to fetch data when the component mounts
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
           'https://kidr78home.duckdns.org/api/loc/users',
           {
             headers: {
               Authorization: 'kSuIlUmNaTiIeO5',
             },
           }
         );
                const data = response.data;
                const allLocationsArray = Object.values(data['kirdrem@gmail.com']);
                const first50Locations = allLocationsArray.slice(0, 2000); // Get the first 50

                // Transform the data
                const transformedLocations = first50Locations.map(item => ({
                lat: item.crds[0], // Assuming latitude is the first element in 'crds' array
                lng: item.crds[1], // Assuming longitude is the second element in 'crds' array
                description: item.description // Extract the description
            }));
                setLocations(transformedLocations); // Update the state with transformed data

                // Set the map center to the coordinates of the first location if available
                if (transformedLocations.length > 0) {
                    setMapCenter([transformedLocations[0].lat, transformedLocations[0].lng]);
                }


            } catch (error) {
                console.error('Error fetching data:', error);
                // You might want to set a default center here if fetching fails
                setMapCenter([60.192059, 24.945831]); // Default center on error
            }
        };

        fetchData(); // Call the fetch function

    }, []); // Empty dependency array ensures this runs only once on mount

    // useEffect to invalidate map size (keep this if necessary for your layout)
    useEffect(() => {
        const map = mapRef.current;
        if (map) {
            const timer = setTimeout(() => {
                map.invalidateSize();
            }, 100);
            return () => {
                clearTimeout(timer); // Clean up the timer
            };
        }
    }, [locations]); // Include locations as a dependency

    // useEffect to apply animation to the first CircleMarker
    useEffect(() => {
        // Check if the first marker's DOM element exists
        if (firstMarkerRef.current) {
            // Target the SVG element rendered by CircleMarker
            const svgElement = firstMarkerRef.current.getElement();

            if (svgElement) {
                 animate(svgElement,
                    {
                      // SVG elements use 'transform' with translate
                      transform: ['translateY(0px)', 'translateY(-10px)', 'translateY(0px)'],
                    },
                    {
                      repeat: Infinity,
                      direction: 'alternate',
                      easing: 'ease-in-out',
                      duration: 1, // Adjust animation duration
                    }
                  );
            }
        }
    }, [locations]); // Re-run animation effect if locations change


    // Don't render the map until the center is determined
    if (!mapCenter) {
        return <div>Loading Map...</div>; // Or some other loading indicator
    }


    return (
        <>
            {/* ... other elements */}

            <MapContainer
                center={mapCenter} // Use the dynamic mapCenter state
                zoom={10} // Adjust initial zoom level as needed
                style={{ height: '1000px', width: '100%' }} // Explicit dimensions
                ref={mapRef}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />

                {/* Render markers from the state */}
                {locations.map((location, index) => {
                    const isFirstMarker = index === 0; // Check if it's the first marker

                    if (isFirstMarker) {
                        return (
                            <CircleMarker
                                key={index}
                                ref={firstMarkerRef} // Attach the ref here
                                center={[location.lat, location.lng]}
                                pathOptions={firstMarkerStyle} // Use the defined style for the first marker
                                radius={8}
                            >
                                <Popup>
                                    {location.description}
                                </Popup>
                            </CircleMarker>
                        );
                    } else {
                        return (
                            <Marker key={index} position={[location.lat, location.lng]}>
                                <Popup>
                                    {location.description}
                                </Popup>
                            </Marker>
                        );
                    }
                })}
            </MapContainer>

            {/* ... other elements */}
        </>
    );
};

export default ScrollableCards;
